import type { ReactNode } from 'react';
import './PhoneFrame.css';

export type PhoneFrameSize = 'sm' | 'md' | 'lg';

export interface PhoneFrameProps {
  children: ReactNode;
  size?: PhoneFrameSize;
  float?: boolean;
  glow?: boolean;
  label?: string;
}

export function PhoneFrame({
  children,
  size = 'md',
  float = false,
  glow = false,
  label,
}: PhoneFrameProps) {
  const className = [
    'poc-phone',
    `poc-phone--${size}`,
    float ? 'poc-phone--float' : '',
    glow ? 'poc-phone--glow' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className='poc-phone-wrap'>
      <div className={className}>
        <div className='poc-phone__bezel'>
          <div className='poc-phone__island' aria-hidden='true' />
          <div className='poc-phone__screen'>{children}</div>
        </div>
      </div>
      {label ? <span className='poc-phone__label'>{label}</span> : null}
    </div>
  );
}
